import type { Workbox } from 'workbox-window'
import type { Messaging } from './index.h'

import { deleteToken, getToken } from 'firebase/messaging'
import { F } from '~/shared/helpers'
import { Logger } from '~/shared/logger'
import { MessageTypes, NotificationPermission } from './index.h'

export const logger = new Logger('tria/features/notifications')

const firebaseConfig = window.ERA_CONFIG?.firebaseConfig || {}

export const requestPermission = (): Promise<boolean> => {
  return Notification.requestPermission()
    .then((permission) => permission === NotificationPermission.GRANTED)
    .catch(F)
}

export const requestToken = ({
  messaging,
  serviceWorkerRegistration,
}: {
  messaging: Messaging
  serviceWorkerRegistration: ServiceWorkerRegistration
}): Promise<string> => {
  const vapidKey = (firebaseConfig.vapidKey || '') as string

  if (!vapidKey)
    throw new Error(
      'vapidKey is missing. Generate vapidKey in firebase and add to app.'
    )

  return getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration,
  })
}
export const unregisterPushNotification = ({
  messaging,
}: {
  messaging: Messaging
}): Promise<unknown> => {
  return deleteToken(messaging)
}

export const setLogoUrlToPushNotifications = ({
  workbox,
  iconUrl,
}: {
  workbox: Workbox
  iconUrl: string
}): Promise<unknown> => {
  return workbox.messageSW({
    type: MessageTypes.SET_APP_ICON,
    iconUrl,
  })
}

export const setActiveProfileRegularToPushNotifications = ({
  workbox,
  isActiveProfileRegular,
}: {
  workbox: Workbox
  isActiveProfileRegular: boolean
}): Promise<unknown> => {
  return workbox.messageSW({
    type: MessageTypes.SET_ACTIVE_PROFILE_REGULAR,
    isActiveProfileRegular,
  })
}
